$ = require('jquery')

require('matchHeight')

module.exports =
	init: (payload) ->
		{$target} = payload

		option =
			byRow: true
			property: 'min-height'
			target: null
			remove: false

		$target.find('.c-services__link').matchHeight(option)
		$target.find('.c-products__top').matchHeight(option)
		$target.find('.c-products__bottom').matchHeight(option)
		$target.find('.c-products__inner').matchHeight(option)
		$target.find('.c-accessories__link').matchHeight(option)
		$target.find('.c-accessories__inner').matchHeight(option)
		$target.find('.c-recommendations__link').matchHeight(option)
		$target.find('.c-recommendations__inner').matchHeight(option)
		$target.find('.c-parts__inner').matchHeight(option)
		$target.find('.b-achievements__name').matchHeight(option)
		$target.find('.b-benefits__inner').matchHeight(option)
		$target.find('.eqHeight').matchHeight(option)
		$target.find('.b-stores__title').matchHeight(option)
		$target.find('.b-stores__desc').matchHeight(option)

		# blog
		$(window)
			.on('load', ->
				$target.find('.c-blog-similar__img').matchHeight(
					byRow: true
					property: 'height'
					target: null
					remove: false
				)
				$target.find('.c-blog-similar__title').matchHeight(option)
		)

		# Compare table
		$target.find('.b-compare').each(->
			$box = $(this)
			$lists = $box.find('.eq-list')
			$items = $lists.find('.eq')
			$sideList = $lists.filter('.b-compare__side__list')

			$sideItems = $sideList.find('.b-compare__side__item')

			$sideItems.each((i, el) ->
				$a = $(el)
				$sameItems = $items.filter((i, b) ->
					return $(b).offset().top is $a.offset().top
				)
				$sameItems.matchHeight(option)
			)
		)



// WEBPACK FOOTER //
// ./src/js/components/matchHeight.coffee